/**
 * Módulo de definiciones de providers para analítica
 * GTM / GA / etc
 * ----
 * @event `route_change` ocurren al cambiar de ruta en la navegación
 * from: Se está abandonando la ruta en cuestión
 * to: Se está yendo a la ruta en cuestión
 * ----
 * @event `interaction_link` ocurren cuando se interactua con links/botones
 */

import { GTM } from "./providers/gtm";

const analyticsDb = {
  triggers: {
    route_change: {
      from: {},
      to: {
        paso1: ["GTM.to_paso1"],
        paso2: ["GTM.to_paso2"],
        paso3: ["GTM.to_paso3"],
        paso4: ["GTM.to_paso4"]
      }
    },
    interaction_link: ["GTM.interaction_link"],
    incomplete: ["GTM.incomplete"],
    uncheck: ["GTM.uncheck"],
    error_backend: ["GTM.error_backend"]
  },
  providers: {
    GTM
  }
};

export default analyticsDb;
